import { createSelector } from 'reselect';
import BalanceOnHandCurrentInfoColumns from '../../containers/BalanceOnHandCurrentInfoColumns';
import TableDefinitions from '../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.VIEW_BOH_CURRENT_INFO.isLoading;
export const getData = TableDefinitions.VIEW_BOH_CURRENT_INFO.getDataFunction();
export const getColumns = createSelector(getData, BalanceOnHandCurrentInfoColumns);
